<template>
  <el-select v-if="config.enabled" v-model="selected" :options="icons"></el-select>
  <p v-else>Icons is not enabled on this CMS. Please contact the site administrator so a developer can enable this feature.</p>
</template>
<script>
import ElSelect from './ElSelect'
export default {
  name: 'IconSelect',
  components: {
    ElSelect
  },
  computed: {
    selected: {
      get() { return this.value },
      set(val) { this.$emit('input', val)}
    },
    config() {
      return this.$inertia.page.props.cms.icons;
    }
  },
  props: ['value'],
  data() {
    return {
      icons: []
    }
  },
  mounted() {
    this.$CMS_GET('icons.index').then((data) => {
      this.icons = data.icons.sort()
    })
  }
}
</script>
